import { render, staticRenderFns } from "./radio-list.vue?vue&type=template&id=283816de&"
import script from "./radio-list.vue?vue&type=script&lang=js&"
export * from "./radio-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports